// HonorCode.jsx
import React, { useEffect, useState } from "react";

import { getConfig } from "@edx/frontend-platform";
import { FormattedMessage, useIntl } from "@edx/frontend-platform/i18n";
import { Form, Hyperlink, Button, Icon } from "@openedx/paragon";
import { faTimes } from "@fortawesome/free-solid-svg-icons"; // Paragon ikonlarını kullanmak için (veya basit bir 'X' koyabiliriz)
import PropTypes from "prop-types";

import messages from "../../messages";

const TERMS_TEXT = (
  <div>
    <h3 className="mb-4">
      Kişisel Verilerin Korunması Kanunu (KVKK) Aydınlatma Metni
    </h3>
    <h4>Veri Sorumlusunun Kimliği</h4>
    <p>
      <b>Veri Sorumlusu:</b> Sanayi ve Teknoloji Bakanlığı
    </p>
    <p>
      <b>Telefon:</b> 444 61 00
    </p>
    <p>
      <b>Web Adresi:</b>{" "}
      <a className="inline-link" href="https://sanayi.gov.tr/anasayfa" target="_blank">
        sanayi.gov.tr
      </a>
    </p>
    <p>
      <b>Adres:</b> Mustafa Kemal Mah. Dumlupınar Bulvarı 2151. Cadde No:154/A
      06530 Çankaya/ANKARA
    </p>
    <h4>Kişisel Verilerin İşlenme Amaçları</h4>
    <p>
      T.C. Sanayi ve Teknoloji Bakanlığının faaliyetlerini sürdürebilmesi için
      KVKK ve ilgili sair Kanun ve mevzuatlar tarafından öngörülen esas ve
      usuller doğrultusunda hukuki yükümlülüklerimizi yerine getirebilmek
      amacıyla kişisel verileriniz işlenmektedir.
    </p>
    <h4>Kişisel Verilerin Üçüncü Kişilere ve/veya Yurt Dışına Aktarılması</h4>
    <p>
      Kişisel verileriniz yurtiçinde hukuken yetkili devlet veya kamu tüzel
      kişilikleri ve Bakanlığın hizmetlerini daha etkin yürütebilmesi için
      zorunlu hallerde ilgili protokol kapsamında 6698 Sayılı Kişisel Verilerin
      Korunması Kanunu’nun 8 inci maddesinde tanımlı hükümlere istinaden gerekli
      önlem ve gizlilik anlaşmaları çerçevesinde ilgili tüzel kişiliklere
      aktarılabilmektedir. Kişisel verilerinizin yurtdışına aktarımı
      yapılmamaktadır.
    </p>
    <h4>Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h4>
    <p>
      Kişisel verileriniz 6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun 5
      inci ve 6 ncı maddelerinde ifade edilen;
    </p>
    <ul>
      <li>
        İlgili kişinin açık rızasının alınması zorunlu hallerde açık rızasına,
      </li>
      <li>Kanunlarda açıkça öngörülmesi,</li>
      <li>
        Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması
        kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin
        gerekli olması,
      </li>
      <li>
        Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu
        olması,
      </li>
      <li>
        Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin
        zorunlu olmasına istinaden; <br />
        kişisel verileriniz Bakanlığımız tarafından; başvuru formları, web
        siteleri üyelik ve iletişim formları, web siteleri e-bülten kayıt
        formları, çerezler, iş başvuru formları gibi kanallarla
        işlenebilmektedir.
      </li>
    </ul>
    <h4>Kişisel Verilere Erişim ve KVKK Kapsamında Haklarınız</h4>
    <p>
      KVKK’nın 11 inci maddesi uyarınca Bakanlığa başvurarak; kişisel
      verilerinizi işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi
      talep etme, kişisel verilerinizin işlenme amacını ve bunların amacına
      uygun kullanılıp kullanılmadığını öğrenme, yurt içinde kişisel
      verilerinizin aktarıldığı üçüncü kişileri bilme, kişisel verilerinizin
      eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme
      ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü
      kişilere bildirilmesini isteme, amaç, süre ve meşruiyet prensipleri
      dahilinde değerlendirilmek üzere kişisel verilerinizin işlenmesini
      gerektiren sebeplerin ortadan kalkması halinde silinmesini veya yok
      edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin
      aktarıldığı üçüncü kişilere bildirilmesini isteme, işlenen kişisel
      verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
      durumunda aleyhinize bir sonucun ortaya çıkması halinde bu sonuca itiraz
      etme, kişisel verilerinizin kanuna aykırı olarak işlenmesi ve bu sebeple
      zarara uğramanız halinde zararın giderilmesini talep etme haklarına
      sahipsiniz.
    </p>
    <p>
      Bu kapsamda, yukarıdaki haklarınıza ilişkin talebinizi Bakanlık internet
      sitesinde bildirilen iletişim kanalları üzerinden dijital ortamda veya
      kimliğinizi tespit edici belgeler ile ıslak imzalı bir dilekçe ile elden
      teslim edebilir ya da noter aracılığıyla gönderebilirsiniz.
    </p>
    <p>
      Bakanlık, haklarınıza ilişkin taleplerinizi, talebin niteliğine göre
      talebi en kısa sürede ve en geç 30 (otuz) gün içerisinde
      sonuçlandıracaktır.
    </p>
    <p>
      Başvurunuzu açık, anlaşılır bir şekilde ve kimlik ile adres bilgilerini
      tespit edici belgeleri de ekleyerek yazılı ve ıslak imzalı olarak elden,
      postayla ya da noter kanalıyla T.C. Sanayi ve Teknoloji Bakanlığı Mustafa
      Kemal Mah. Dumlupınar Bulvarı 2151. Cadde No:154/A 06530 Çankaya/ANKARA
      adresine ulaştırmanız gerekmektedir.
    </p>
    <p>
      Bu kapsamdaki başvurular tarafımızdan yapılacak olan kimlik doğrulamasını
      takiben kabul edilecek olup ilgi kişilere yasal süreler içerisinde yazılı
      olarak veya elektronik ortamda cevap verilecektir.
    </p>
  </div>
);

const PRIVACY_TEXT = (
  <div>
    <h3>Gizlilik Politikası</h3>
    <p>Buraya gizlilik politikası metni gelecek...</p>
    <p>Kişisel verilerinizin işlenmesi hakkında detaylı bilgiler...</p>
  </div>
);

const HonorCode = (props) => {
  const { formatMessage } = useIntl();
  const { errorMessage, onChangeHandler, fieldType, value } = props;

  // Hangi modalın açık olduğunu tutan state (null, 'tos', 'privacy')
  const [activeModal, setActiveModal] = useState(null);

  // Scroll kilitleme ve açma işlemi
  useEffect(() => {
    if (activeModal) {
      // Modal açıksa scroll'u kapat
      document.body.style.overflow = "hidden";
    } else {
      // Modal kapalıysa scroll'u eski haline getir
      document.body.style.overflow = "unset";
    }

    // Component unmount olursa scroll'u temizle
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [activeModal]);

  // Checkbox otomatik işaretleme mantığı (Senin kodundaki mevcut mantık)
  useEffect(() => {
    if (fieldType === "tos_and_honor_code" && !value) {
      onChangeHandler({ target: { name: "honor_code", value: true } });
    }
  }, [fieldType, onChangeHandler, value]);

  // Modal Kapatma Fonksiyonu
  const closeModal = () => setActiveModal(null);

  // Modal İçeriğini Render Eden Helper
  const renderModal = () => {
    if (!activeModal) return null;

    const content = activeModal === "tos" ? TERMS_TEXT : PRIVACY_TEXT;

    return (
      <div style={styles.overlay} onClick={closeModal}>
        <div style={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
          <div style={styles.header}>
            <button
              type="button"
              style={styles.closeButton}
              onClick={closeModal}
            >
              {/* FontAwesome ikonun yoksa buraya sadece "X" yazabilirsin */}
              <span style={{ fontSize: "24px", lineHeight: "1" }}>&times;</span>
            </button>
          </div>
          <div style={styles.scrollableContent}>{content}</div>
          <div style={styles.footer}>
            <Button variant="primary" onClick={closeModal}>
              <FormattedMessage id="modal.close" defaultMessage="Kapat" />
            </Button>
          </div>
        </div>
      </div>
    );
  };

  // Linke tıklandığında çalışacak fonksiyon
  const handleLinkClick = (e, type) => {
    e.preventDefault(); // Sayfa yenilenmesini/gitmesini engelle
    setActiveModal(type);
  };

  if (fieldType === "tos_and_honor_code") {
    return (
      <>
        {renderModal()}
        <div id="honor-code" className="micro text-muted mt-4">
          <FormattedMessage
            id="register.page.terms.of.service.and.honor.code"
            defaultMessage="By creating an account, you agree to the {tosAndHonorCode} and you acknowledge that {platformName} and each Member process your personal data in accordance with the."
            description="Text that appears on registration form stating honor code and privacy policy"
            values={{
              platformName: getConfig().SITE_NAME,
              tosAndHonorCode: (
                <Hyperlink
                  className="inline-link"
                  destination="#"
                  onClick={(e) => handleLinkClick(e, "tos")}
                >
                  {formatMessage(messages["personal.data.protection.law"])}
                </Hyperlink>
              ),
              // privacyPolicy: (
              //   <Hyperlink
              //     className="inline-link"
              //     destination="#"
              //     onClick={(e) => handleLinkClick(e, "privacy")}
              //   >
              //     {formatMessage(messages["privacy.policy"])}
              //   </Hyperlink>
              // ),
            }}
          />
        </div>
      </>
    );
  }

  return (
    <>
      {renderModal()}
      <div id="honor-code" className="micro text-muted">
        <Form.Checkbox
          className="form-field--checkbox mt-1"
          id="honor-code"
          checked={value}
          name="honor_code"
          value={value}
          onChange={onChangeHandler}
        >
          <FormattedMessage
            id="register.page.honor.code"
            defaultMessage="I agree to the {platformName}&nbsp;{tosAndHonorCode}"
            description="Text that appears on registration form stating honor code"
            values={{
              platformName: getConfig().SITE_NAME,
              tosAndHonorCode: (
                <Hyperlink
                  variant="muted"
                  destination="#"
                  onClick={(e) => handleLinkClick(e, "tos")}
                >
                  {formatMessage(messages["honor.code"])}
                </Hyperlink>
              ),
            }}
          />
        </Form.Checkbox>
        {errorMessage && (
          <Form.Control.Feedback
            type="invalid"
            className="form-text-size"
            hasIcon={false}
          >
            {errorMessage}
          </Form.Control.Feedback>
        )}
      </div>
    </>
  );
};

// Inline Styles (MFE içinde ayrı CSS dosyasıyla uğraşmaman için buraya ekledim)
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)", // Koyu arka plan
    backdropFilter: "blur(5px)", // Bulanıklaştırma efekti
    zIndex: 9999, // Her şeyin üstünde
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  modalContainer: {
    backgroundColor: "#ffffff",
    width: "100%",
    maxWidth: "720px", // Çok geniş olmasın
    maxHeight: "80vh", // Ekranın taşmaması için
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    animation: "fadeIn 0.3s ease",
  },
  header: {
    padding: "10px 15px",
    display: "flex",
    justifyContent: "flex-end",
    borderBottom: "1px solid #eee",
  },
  closeButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#666",
    padding: "5px",
  },
  scrollableContent: {
    padding: "20px",
    overflowY: "auto", // Metin uzunsa sadece burası scroll olsun
    flex: 1,
    lineHeight: "1.6",
    fontSize: "14px",
    color: "#333",
  },
  footer: {
    padding: "15px",
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "flex-end",
  },
};

HonorCode.defaultProps = {
  errorMessage: "",
  onChangeHandler: null,
  fieldType: "honor_code",
  value: false,
};

HonorCode.propTypes = {
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func,
  fieldType: PropTypes.string,
  value: PropTypes.bool,
};

export default HonorCode;
